import { render, staticRenderFns } from "./advantage.vue?vue&type=template&id=ca60bb50&"
import script from "./advantage.vue?vue&type=script&lang=js&"
export * from "./advantage.vue?vue&type=script&lang=js&"
import style0 from "./advantage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca60bb50')) {
      api.createRecord('ca60bb50', component.options)
    } else {
      api.reload('ca60bb50', component.options)
    }
    module.hot.accept("./advantage.vue?vue&type=template&id=ca60bb50&", function () {
      api.rerender('ca60bb50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/advantage/advantage.vue"
export default component.exports